<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>Contents</h1><ol><li id="level1-titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></li>
<li id="level1-toc"><a href="#/toc">Contents</a></li>
<li id="level1-front3"><a href="#/front01">Copyright</a></li>
<li id="level1-front4"><a href="#/front02">Introduction</a></li>
<li id="c001"><a href="#/c001">Cezary Strzybisz, Necrobes</a>
<ol>
<li id="c01"><a href="#/c01">Introduction</a></li>
</ol>
</li>
<li id="c002"><a href="#/c002">Reginald Gulliver, Eruntics</a>
<ol>
<li id="c02"><a href="#/c02">Introduction</a></li>
</ol>
</li>
<li id="c003"><span href="#/c003" title="Link target outside of Sample">Juan Rambellais et. al., A History of Bitic Literature, Volume I</span>
<ol>
<li id="c03"><span href="#/c03" title="Link target outside of Sample">Introduction</span></li>
<li id="c04"><span href="#/c04" title="Link target outside of Sample">Introduction to the Second Edition</span></li>
</ol>
</li>
<li id="c004"><span href="#/c004" title="Link target outside of Sample">Vestrand’s Extelopedia in 44 Magnetomes</span>
<ol>
<li id="c05"><span href="#/c05" title="Link target outside of Sample">Proffertinc</span></li>
<li id="c06"><span href="#/c06" title="Link target outside of Sample">Sample Pages</span></li>
</ol>
</li>
<li id="c005"><span href="#/c005" title="Link target outside of Sample">GOLEM XIV</span>
<ol>
<li id="c07"><span href="#/c07" title="Link target outside of Sample">Foreword</span></li>
<li id="c08"><span href="#/c08" title="Link target outside of Sample">Introduction</span></li>
<li id="c09"><span href="#/c09" title="Link target outside of Sample">Instructions</span></li>
<li id="c10"><span href="#/c10" title="Link target outside of Sample">Golem’s Inaugural Lecture—About Man Threefold</span></li>
<li id="c11"><span href="#/c11" title="Link target outside of Sample">Lecture XLIII—About Itself</span></li>
<li id="c12"><span href="#/c12" title="Link target outside of Sample">Afterword</span></li>
</ol>
</li>
<li id="level1-back37"><span href="#/back01" title="Link target outside of Sample">About the Author</span></li>
<li id="level1-footnotes"><span href="#/footnotes" title="Link target outside of Sample">Footnotes</span></li></ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?f50a97f2